import { render, staticRenderFns } from "./TopicLabelBox.vue?vue&type=template&id=acfff6cc&scoped=true&"
import script from "./TopicLabelBox.vue?vue&type=script&lang=js&"
export * from "./TopicLabelBox.vue?vue&type=script&lang=js&"
import style0 from "./TopicLabelBox.vue?vue&type=style&index=0&id=acfff6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfff6cc",
  null
  
)

export default component.exports